<template>
    <v-container
        fluid
        class="py-2 pl-2 pr-2 pb-1"
        :style="$vuetify.display.mobile ? 'width: 100vw;' : ''"
    >
        <!-- desktop view -->
        <template v-if="!$vuetify.display.mobile">
            <v-window v-model="step">
                <v-window-item key="0">
                    <v-row no-gutters v-if="step === 0" class="justify-center">
                        <v-col cols="7" class="pr-1">
                            <v-card class="default_card_wm elevation-0 pt-2">
                                <DocumentMenu 
                                    :MenuOptions="documentMenuOptions"
                                    @back="back()"
                                    @display-file="leftPart = 'document'"
                                    @display-accounting-line="leftPart = 'accountingLines'"
                                    @activity="leftPart = 'displayActivity'"
                                    @delete="deleteDialog = true"
                                />
                                <v-row no-gutters>
                                    <!--<v-col cols="6">
                                        <v-btn-back @click="back()" v-if="mode !== 'GeneralLedger'">
                                        </v-btn-back>
                                    </v-col>
                                    <v-col cols="6" class="d-flex justify-end">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ props }">
                                                <v-btn-icon
                                                    icon="$dots_vertical"
                                                    v-bind="props"
                                                    class="mx-1"
                                                    color="secondary"
                                                    data-cy="ExpenseReport2-more"
                                                />
                                            </template>
                                            <v-list nav rounded="xl">
                                                <v-list-item
                                                    @click="leftPart = 'document'"
                                                    v-if="
                                                        expenseReport.status === 'VALIDATED' &&
                                                        isAccountingUser
                                                    "
                                                    title="Documents"
                                                >
                                                    <template v-slot:append>
                                                        <v-icon size="small">$oss-file</v-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="leftPart = 'accountingLines'"
                                                    v-if="
                                                        expenseReport.status === 'VALIDATED' &&
                                                        isAccountingUser
                                                    "
                                                    title="&#xc9;critures comptables"
                                                >
                                                    >
                                                    <template v-slot:append>
                                                        <v-icon size="small"
                                                            >$oss-accounting-lines</v-icon
                                                        >
                                                    </template>
                                                </v-list-item>
                                                <v-list-item
                                                    @click="leftPart = 'displayActivity'"
                                                    v-if="isAccountingUser"
                                                    title="Afficher l'activité"
                                                >
                                                    <template v-slot:append>
                                                        <v-icon size="small">$oss-activity</v-icon>
                                                    </template>
                                                </v-list-item>
                                                <v-divider class="pb-2" />
                                                <v-list-item
                                                    @click="deleteDialog = true"
                                                    color="red"
                                                    data-cy="ExpenseReport2-delete"
                                                    :active="true"
                                                    title="Supprimer"
                                                >
                                                    <template v-slot:append>
                                                        <v-icon size="small">$oss-trash</v-icon>
                                                    </template>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>-->
                                    <!-- <v-col class="d-flex justify-end align-center">
                                    <v-btn color="primary" icon elevation="0" @click="startTuto()">
                                        <v-icon>$oss-help</v-icon>
                                    </v-btn>
                                </v-col> -->
                                </v-row>
                                <v-window v-model="leftPart">
                                    <!-- avant c'était document-->
                                    <v-window-item :value="'accountingLines'">
                                        <div
                                            style="height: calc(100vh - 130px); overflow-y: hidden"
                                            v-if="expenseReport && expenseReport.id && companyId"
                                        >
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <!-- //! ACCOUNTING ITEM STATIC -> Change documentId -->
                                                    <accounting-item-static
                                                        :companyId="companyId"
                                                        :expenseReportId="id"
                                                        mode="Embedded"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </v-window-item>
                                    <v-window-item :key="refreshKey" :value="'document'">
                                        <div
                                            style="
                                                height: calc(100vh - 130px);
                                                overflow-y: auto;
                                                margin-left: 0 auto;
                                                padding: auto;
                                            "
                                        >
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="12"
                                                    class="justify-center"
                                                    v-if="displayHereMap"
                                                >
                                                    <HereMap
                                                        :origin="hereMapData.origin"
                                                        :destination="hereMapData.destination"
                                                        :vehiculeType="hereMapData.vehiculeType"
                                                    />
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    v-else-if="!isPDF"
                                                    id="InvoiceDocumentValidation"
                                                >
                                                    <div
                                                        style="
                                                            position: relative;
                                                            width: 100%;
                                                            height: 0;
                                                            padding: 0;
                                                            padding-bottom: 141.4516129032258%;
                                                            margin-bottom: 50px;
                                                        "
                                                    >
                                                        <svg
                                                            id="svg-document-validation"
                                                            v-if="selectedDocument"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="100%"
                                                            :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                                            style="
                                                                position: absolute;
                                                                width: 100%;
                                                                left: 0;
                                                                top: 0;
                                                                background: #fff;
                                                            "
                                                        >
                                                            <image
                                                                id="svg-image-document-validation"
                                                                :xlink:href="
                                                                    selectedDocument.signedUrl
                                                                "
                                                                x="0"
                                                                y="0"
                                                                :height="`${imageHeight}px`"
                                                                :width="`${imageWidth}px`"
                                                            />
                                                        </svg>
                                                    </div>
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    v-else-if="isPDF"
                                                    class="d-flex justify-center"
                                                    style="
                                                        height: calc(100vh - 130px);
                                                        overflow-y: auto;
                                                    "
                                                    id="InvoiceDocumentValidation"
                                                >
                                                    <ossPdf :documentId="selectedDocument.id" />
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </v-window-item>
                                    <v-window-item :value="'displayActivity'">
                                        <v-col
                                            cols="12"
                                            style="height: calc(100vh - 130px); overflow-y: auto"
                                        >
                                            <UsersActivitiesHistory
                                                :expenseReportId="expenseReport.id"
                                            >
                                            </UsersActivitiesHistory>
                                        </v-col>
                                    </v-window-item>
                                </v-window>
                            </v-card>
                        </v-col>
                        <v-col :cols="5" class="my-0 pl-1">
                            <v-card
                                style="
                                    border-top-right-radius: 0px !important;
                                    border-bottom-right-radius: 0px !important;
                                    height: calc(100vh - 82px);
                                    overflow-y: none;
                                "
                                class="default_card_wm elevation-0"
                            >
                                <div style="height: calc(100vh - 130px); overflow-y: auto">
                                    <v-row no-gutters class="pl-2 pr-2">
                                        <v-col cols="12" class="pt-3">
                                            <v-list-item
                                                border
                                                :ripple="false"
                                                class="mt-2 mb-1 rounded-xl"
                                                id="StatutNoteDeFrais"
                                            >
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters class="align-center">
                                                        <v-col
                                                            cols="3"
                                                            style="
                                                                border-right: 1px #ededed solid;
                                                                height: 28px;
                                                            "
                                                            class="d-flex align-center"
                                                        >
                                                            <b>Statut</b>
                                                        </v-col>
                                                        <v-col cols="9" class="pl-2">
                                                            {{ statusText }}
                                                        </v-col>
                                                    </v-row>
                                                </v-list-item-title></v-list-item
                                            >
                                        </v-col>
                                        <v-col cols="12">
                                            <v-list-item
                                                border
                                                :ripple="false"
                                                class="my-1 rounded-xl"
                                                id="createByNoteDeFrais"
                                            >
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters class="align-center">
                                                        <v-col
                                                            cols="3"
                                                            style="
                                                                border-right: 1px #ededed solid;
                                                                height: 28px;
                                                            "
                                                            class="d-flex align-center"
                                                        >
                                                            <b>Créé par</b>
                                                        </v-col>
                                                        <v-col cols="9" class="pl-2" v-if="creator">
                                                            {{ creator.firstname }}
                                                            {{ creator.lastname }}
                                                        </v-col>
                                                    </v-row>
                                                </v-list-item-title></v-list-item
                                            >
                                        </v-col>
                                        <v-col cols="12">
                                            <v-list-item
                                                border
                                                :ripple="false"
                                                class="my-1 rounded-xl"
                                                id="NameNoteDeFrais"
                                            >
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters class="align-center">
                                                        <v-col
                                                            cols="3"
                                                            style="
                                                                border-right: 1px #ededed solid;
                                                                height: 28px;
                                                            "
                                                            class="d-flex align-center"
                                                        >
                                                            <b>Nom</b>
                                                        </v-col>
                                                        <v-col cols="9" class="pl-2">
                                                            <v-text-field-filled
                                                                v-model="expenseReport.name"
                                                                outlined
                                                                hide-details
                                                                :readonly="
                                                                    expenseReport.status ===
                                                                    'VALIDATED'
                                                                "
                                                                density="compact"
                                                            />
                                                        </v-col> </v-row></v-list-item-title
                                            ></v-list-item>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-list-item
                                                border
                                                :ripple="false"
                                                class="my-1 rounded-xl"
                                                id="DateNoteDeFrais"
                                            >
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters class="align-center">
                                                        <v-col
                                                            cols="3"
                                                            style="
                                                                border-right: 1px #ededed solid;
                                                                height: 28px;
                                                            "
                                                            class="d-flex align-center"
                                                        >
                                                            <b>Date</b>
                                                        </v-col>
                                                        <v-col cols="9" class="pl-2">
                                                            <oss-date-picker
                                                                v-model="expenseReport.date"
                                                                :outlined="true"
                                                                :hide-details="true"
                                                                :readonly="
                                                                    !commonEnableModification
                                                                "
                                                                :disabled="
                                                                    expenseReport.status ===
                                                                    'VALIDATED'
                                                                "
                                                                :textFieldReadOnly="false"
                                                            />
                                                        </v-col> </v-row></v-list-item-title
                                            ></v-list-item>
                                        </v-col>
                                        <v-col cols="12" v-if="expenseReport.expenseReport">
                                            <v-list-item
                                                border
                                                :ripple="false"
                                                class="my-1 rounded-xl"
                                                id="TagNoteDeFrais"
                                            >
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters class="align-center">
                                                        <!-- <v-col cols="3" style="border-right: 1px #EDEDED solid; height: 28px" class="d-flex align-center">
                                                            <b>Étiquette</b>
                                                        </v-col> -->
                                                        <v-col class="pl-2">
                                                            <free-tag
                                                                :document="
                                                                    expenseReport.expenseReport
                                                                "
                                                                :company="companyId"
                                                                :splitUserPartitions="true"
                                                                :companyTags="allCompanyTags"
                                                            />
                                                        </v-col> </v-row></v-list-item-title
                                            ></v-list-item>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-list-item
                                                border
                                                :ripple="false"
                                                class="my-1 rounded-xl"
                                                id="CollaborationNoteDeFrais"
                                            >
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters class="align-center">
                                                        <v-col
                                                            cols="3"
                                                            style="
                                                                border-right: 1px #ededed solid;
                                                                height: 28px;
                                                            "
                                                            class="d-flex align-center"
                                                        >
                                                            <b>Collaborateur</b>
                                                        </v-col>
                                                        <v-col cols="9" class="pl-2">
                                                            <v-text-field-filled
                                                                outlined
                                                                readonly
                                                                hide-details
                                                                @click.stop="userDialog = true"
                                                                :value="expenseReportUser"
                                                                density="compact"
                                                            />
                                                        </v-col> </v-row></v-list-item-title
                                            ></v-list-item>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        class="pt-2 pb-3"
                                        v-if="
                                            (expenseReport.status === 'VALIDATED' &&
                                                documents.length) ||
                                            expenseReport.status !== 'VALIDATED'
                                        "
                                        id="SupportingDocumentsNoteDeFrais"
                                    >
                                        <v-col class="d-flex align-center v-col-auto pr-3">
                                            Justificatif de note de frais ({{
                                                $t("shared.amountOfFiles", documents.length || 0, {
                                                    count: documents.length || 0,
                                                })
                                            }})
                                        </v-col>
                                        <v-col class="d-flex align-center">
                                            <v-divider />
                                        </v-col>
                                        <v-col
                                            class="d-flex align-center v-col-auto pl-3"
                                            v-if="expenseReport.status !== 'VALIDATED'"
                                        >
                                            <v-btn-add-icon
                                                size="x-small"
                                                @click="
                                                    activeUploadDocuments = true;
                                                    activeTravelExpense = false;
                                                "
                                            >
                                            </v-btn-add-icon>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <div v-for="doc of documents" :key="doc.id">
                                                <div
                                                    v-if="isAccountingUser"
                                                    style="
                                                        position: relative;
                                                        top: -12px;
                                                        left: 20px;
                                                        right: auto;
                                                        z-index: 1;
                                                        height: 0px;
                                                    "
                                                >
                                                    <v-chip
                                                        :color="
                                                            doc.status === 'VALIDATED' &&
                                                            doc.accountableAccount &&
                                                            doc.accountableAccount.name &&
                                                            doc.accountableAccount.name !== '600000'
                                                                ? 'primary'
                                                                : 'grey'
                                                        "
                                                        style="background: #fff !important"
                                                        size="small"
                                                        variant="outlined"
                                                    >
                                                        {{
                                                            $t(
                                                                "document.status." +
                                                                    getDocumentStatus(doc),
                                                            )
                                                        }}
                                                        <v-icon
                                                            v-if="
                                                                doc.status === 'VALIDATED' &&
                                                                doc.accountableAccount &&
                                                                doc.accountableAccount.name &&
                                                                doc.accountableAccount.name !==
                                                                    '600000'
                                                            "
                                                            size="small"
                                                            right
                                                            >$check</v-icon
                                                        >
                                                    </v-chip>
                                                </div>
                                                <v-list-item
                                                    border
                                                    :ripple="false"
                                                    class="mb-5 rounded-xl"
                                                    @click="setSelectedDocument(doc)"
                                                >
                                                    <template #prepend>
                                                        <v-icon>$oss-file</v-icon>
                                                    </template>

                                                    <v-list-item-title>
                                                        <v-row no-gutters>
                                                            <v-col cols="6" class="pr-1">
                                                                <v-text-field-filled
                                                                    v-model="doc.name"
                                                                    label="Nom du document"
                                                                    outlined
                                                                    hide-details
                                                                    class="mt-1"
                                                                    :readonly="
                                                                        expenseReport.status ===
                                                                        'VALIDATED'
                                                                    "
                                                                    density="compact"
                                                                />
                                                            </v-col>
                                                            <v-col cols="5">
                                                                <v-select-filled
                                                                    v-if="doc.accountableAccount"
                                                                    v-model="
                                                                        doc.accountableAccount.name
                                                                    "
                                                                    item-title="text"
                                                                    :items="categories"
                                                                    @update:model-value="
                                                                        categoryChange(doc)
                                                                    "
                                                                    outlined
                                                                    label="Catégorie"
                                                                    class="mt-1"
                                                                    hide-details
                                                                    :readonly="
                                                                        expenseReport.status ===
                                                                        'VALIDATED'
                                                                    "
                                                                    density="compact"
                                                                />
                                                            </v-col>
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex align-center justify-center"
                                                            >
                                                                <v-btn-icon
                                                                    icon="$oss-edit"
                                                                    @click="routeDocument(doc.id)"
                                                                    size="small"
                                                                />
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>
                                                        <v-row
                                                            no-gutters
                                                            class="pt-1"
                                                            v-if="
                                                                doc.status ===
                                                                    'ORIGINAL_UPLOADED' ||
                                                                doc.status === 'UPLOADED'
                                                            "
                                                            align-content="center"
                                                            justify="center"
                                                        >
                                                            <v-col
                                                                cols="11"
                                                                class="text-center py-2"
                                                            >
                                                                En cours d'analyse
                                                            </v-col>
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex align-center justify-center"
                                                            >
                                                                <v-btn-trash
                                                                    v-if="
                                                                        expenseReport.status !==
                                                                        'VALIDATED'
                                                                    "
                                                                    @click="deleteDocument(doc.id)"
                                                                    size="small"
                                                                />
                                                            </v-col>
                                                            <v-col cols="11">
                                                                <v-progress-linear
                                                                    indeterminate
                                                                    rounded
                                                                    height="6"
                                                                />
                                                            </v-col>
                                                            <v-col cols="1"> </v-col>
                                                        </v-row>
                                                        <v-row no-gutters class="pt-1" v-else>
                                                            <v-col class="pr-1">
                                                                <v-text-field-filled
                                                                    label="Date"
                                                                    hide-details
                                                                    readonly
                                                                    :model-value="
                                                                        formatDate(doc.date)
                                                                    "
                                                                />
                                                            </v-col>
                                                            <v-col class="pr-1">
                                                                <v-text-field-filled
                                                                    v-model="doc.netAmount"
                                                                    label="HT"
                                                                    readonly
                                                                    append-inner-icon="$euro"
                                                                    hide-details
                                                                />
                                                            </v-col>
                                                            <v-col>
                                                                <v-text-field-filled
                                                                    v-model="doc.grossAmount"
                                                                    label="TTC"
                                                                    readonly
                                                                    append-inner-icon="$euro"
                                                                    hide-details
                                                                />
                                                            </v-col>
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex align-center justify-center"
                                                            >
                                                                <v-btn-trash
                                                                    @click="deleteDocument(doc.id)"
                                                                    v-if="
                                                                        expenseReport.status !==
                                                                        'VALIDATED'
                                                                    "
                                                                    size="small"
                                                                />
                                                            </v-col>
                                                        </v-row> </v-list-item-subtitle
                                                ></v-list-item>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        class="py-1"
                                        v-if="
                                            (expenseReport.status === 'VALIDATED' &&
                                                travelExpenses.length) ||
                                            expenseReport.status !== 'VALIDATED'
                                        "
                                        id="TravellingExpensesNoteDeFrais"
                                    >
                                        <v-col class="d-flex align-center v-col-auto pr-3">
                                            Frais de déplacement
                                        </v-col>
                                        <v-col class="d-flex align-center">
                                            <v-divider />
                                        </v-col>
                                        <v-col
                                            class="d-flex align-center v-col-auto pl-3"
                                            v-if="expenseReport.status !== 'VALIDATED'"
                                        >
                                            <v-btn-add-icon
                                                size="x-small"
                                                @click="
                                                    activeUploadDocuments = false;
                                                    activeTravelExpense = true;
                                                    currentTravelExpenseDocument = null;
                                                "
                                            >
                                            </v-btn-add-icon>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-list lines="two">
                                                <v-list-item
                                                    border
                                                    :ripple="false"
                                                    class="mb-2 rounded-xl"
                                                    v-for="doc of travelExpenses"
                                                    :key="doc.id"
                                                    @click="setSelectedDocument(doc)"
                                                >
                                                    <template #prepend>
                                                        <v-icon>$oss-car</v-icon>
                                                    </template>

                                                    <v-list-item-title>
                                                        <v-row no-gutters>
                                                            <v-col cols="11">
                                                                <v-text-field-filled
                                                                    v-model="doc.name"
                                                                    label="Nom du document"
                                                                    outlined
                                                                    hide-details
                                                                    :readonly="
                                                                        expenseReport.status ===
                                                                        'VALIDATED'
                                                                    "
                                                                    class="mt-1"
                                                                    density="compact"
                                                                />
                                                            </v-col>
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex align-center justify-center"
                                                            >
                                                                <v-btn-icon
                                                                    icon="$oss-edit"
                                                                    @click="openDocument(doc)"
                                                                    size="small"
                                                                />
                                                            </v-col>
                                                        </v-row>
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle v-model="hereAddressData">
                                                        <v-row no-gutters class="pt-1">
                                                            <v-col class="pr-1">
                                                                <v-text-field-filled
                                                                    label="Date"
                                                                    outlined
                                                                    readonly
                                                                    hide-details
                                                                    :model-value="
                                                                        formatDate(doc.date)
                                                                    "
                                                                    density="compact"
                                                                />
                                                            </v-col>
                                                            <v-col class="pr-1">
                                                                <v-text-field-filled
                                                                    v-model="doc.netAmount"
                                                                    label="HT"
                                                                    outlined
                                                                    readonly
                                                                    dense
                                                                    append-inner-icon="$euro"
                                                                    hide-details
                                                                />
                                                            </v-col>
                                                            <v-col>
                                                                <v-text-field-filled
                                                                    v-model="doc.grossAmount"
                                                                    label="TTC"
                                                                    outlined
                                                                    readonly
                                                                    dense
                                                                    append-inner-icon="$euro"
                                                                    hide-details
                                                                />
                                                            </v-col>
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex align-center justify-center"
                                                            >
                                                                <v-btn-trash
                                                                    v-if="
                                                                        expenseReport.status !==
                                                                        'VALIDATED'
                                                                    "
                                                                    @click="deleteDocument(doc.id)"
                                                                    size="small"
                                                                />
                                                            </v-col>
                                                        </v-row> </v-list-item-subtitle
                                                ></v-list-item>
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <!-- // ** details prices table -->
                                        <v-col cols="12" v-if="showDetail">
                                            <v-row no-gutters class="py-2 align-center">
                                                <v-col class="v-col-auto pr-3"> Détails </v-col>
                                                <v-col>
                                                    <v-divider />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" class="py-2 mb-2" v-if="showDetail">
                                            <accounting-item-static
                                                :companyId="companyId"
                                                :expenseReportId="id"
                                                @update="refresh"
                                                mode="Payment"
                                            />
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-card-actions class="d-flex justify-end">
                                    <div class="d-flex mr-4">
                                        <v-btn-prev :disabled="prevDisabled" @click="prev()" />
                                        <v-btn-next :disabled="nextDisabled" @click="next()" />
                                    </div>
                                    <v-btn
                                        v-if="
                                            expenseReport.status === 'EDITION' ||
                                            expenseReport.status === 'INFORMATION_REQUEST'
                                        "
                                        color="primary"
                                        class="mx-1"
                                        @click="(save(), valideDestination())"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        class="mx-1"
                                        @click="submit()"
                                        :disabled="disabledSubmit"
                                        id="ValidNoteDeFrais"
                                        data-cy="ExpenseReport2-valid"
                                        size="small"
                                    >
                                        {{ submitTitle }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-window-item>
                <v-window-item key="1">
                    <DocumentRouterInExpenseReport
                        v-if="selectedDocumentId && step === 1"
                        :mode="'ExpenseReport'"
                        :companyId="companyId"
                        :id="selectedDocumentId"
                        :dark-mode="false"
                        @back="step = 0"
                    />
                </v-window-item>
            </v-window>
        </template>
        <!-- Mobile view -->
        <div v-else class="px-0 pt-2" style="width: 96vw">
            <v-row no-gutters class="pb-2">
                <v-col cols="6" class="px-1 d-flex justify-center">
                    <v-btn
                        rounded
                        @click="
                            activeUploadDocuments = true;
                            activeTravelExpense = false;
                        "
                        class="btn"
                        size="small"
                        >Nouvelles factures</v-btn
                    >
                </v-col>
                <v-col cols="6" class="px-1 d-flex justify-center">
                    <v-btn
                        class="btn"
                        rounded
                        @click="
                            activeUploadDocuments = false;
                            activeTravelExpense = true;
                            currentTravelExpenseDocument = null;
                        "
                        size="small"
                        >Frais kilométriques</v-btn
                    >
                </v-col>
            </v-row>
            <v-row no-gutters class="py-2">
                <v-col cols="12">
                    <v-text-field
                        outlined
                        v-model="expenseReport.name"
                        label="Nom de la note de frais"
                        hide-details
                        density="compact"
                    />
                </v-col>
            </v-row>
            <v-divider class="pb-1 pt-0" />
            <v-row
                no-gutters
                class="pb-2 pt-3 pl-0"
                style="max-height: calc(100vh - 258px); overflow-y: auto"
            >
                <v-col
                    cols="12"
                    class="pb-2"
                    v-for="(item, index) of expenseReport.documents"
                    :key="index"
                >
                    <!-- <swipe-out> -->
                    <!-- <template v-slot:right>
                            <div
                                class="swipeout-action red d-flex align-center px-6"
                                title="remove"
                                @click="deleteDocument(item.id)"
                            >
                                <v-icon color="#FFF" size="small">$oss-trash</v-icon>
                            </div>
                        </template> -->
                    <v-card
                        elevation="0"
                        style="border-radius: 8px"
                        @click.stop="openDocument(item)"
                        :loading="item.status === 'ORIGINAL_UPLOADED' || item.status === 'UPLOADED'"
                    >
                        <template v-slot:loader="{ isActive }">
                            <div v-if="isActive">
                                <v-progress-linear indeterminate />
                                <span class="px-2 pt-1">En cours d'analyse ...</span>
                            </div>
                        </template>
                        <div class="px-2 pb-2">
                            <v-row no-gutters class="pt-2">
                                <v-col
                                    cols="10"
                                    style="
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                    "
                                >
                                    {{ getCategoryText(item.accountableAccount) }}
                                </v-col>
                                <v-col cols="2" class="d-flex justify-end">
                                    <div
                                        v-if="
                                            item.status === 'ORIGINAL_UPLOADED' ||
                                            item.status === 'UPLOADED'
                                        "
                                        class="text-center"
                                    />
                                    <div v-else class="d-flex align-center justify-center">
                                        <v-icon color="secondary" v-if="item.signedUrl"
                                            >$oss-file</v-icon
                                        >
                                        <v-icon color="secondary" v-else-if="item.travelExpense"
                                            >$oss-car</v-icon
                                        >
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row
                                no-gutters
                                v-if="
                                    !(
                                        item.status === 'ORIGINAL_UPLOADED' ||
                                        item.status === 'UPLOADED'
                                    )
                                "
                            >
                                <v-col
                                    style="
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                    "
                                    class="flex-grow-0 flex-shrink-1"
                                    cols="6"
                                >
                                    <v-icon
                                        v-if="item.date"
                                        color="secondary"
                                        size="small"
                                        location="start"
                                        >$oss-calendar</v-icon
                                    >{{ getDateFormated(item.date) }}
                                </v-col>
                                <v-col cols="6" class="d-flex align-center justify-end">
                                    {{
                                        item.netAmount
                                            ? newCommonFormatCurrency(item.netAmount, undefined)
                                            : "-"
                                    }}
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                    <!-- </swipe-out> -->
                </v-col>
                <v-col cols="12" class="justify-center" v-if="displayHereMap">
                    <HereMap
                        :origin="hereMapData.origin"
                        :destination="hereMapData.destination"
                        :vehiculeType="hereMapData.vehiculeType"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters class="d-flex align-self-end">
                <v-col cols="12" class="d-flex justify-center px-1" v-if="commonEnableModification">
                    <v-btn-primary block @click="submit()" :disabled="disabledSubmit" size="large">
                        {{ submitTitle }}
                    </v-btn-primary>
                </v-col>
                <v-col cols="4" xs4 class="d-flex justify-center" v-if="createBottomToolbar()">
                    <v-btn class="btn" size="small" @click="setOpenChat('DENIED')" icon="$clear">
                    </v-btn>
                </v-col>
                <v-col cols="4" class="d-flex justify-center" v-if="createBottomToolbar()">
                    <v-btn
                        size="small"
                        @click="setOpenChat('INFORMATION_REQUEST')"
                        icon="$fa-comments"
                    >
                    </v-btn>
                </v-col>
                <v-col cols="4" class="d-flex justify-center" v-if="createBottomToolbar()">
                    <v-btn size="small" @click="valid()" icon="$check"> </v-btn>
                </v-col>
            </v-row>
            <oss-dialog
                v-model="accountableAccountDialog"
                title="Type de facture"
                class="px-2"
                v-if="accountableAccountDialog"
            >
                <v-row no-gutters>
                    <v-col cols="12" class="px-2">
                        <v-select-filled
                            v-model="selectedDocument['accountableAccount']['name']"
                            :items="categories"
                            @update:model-value="categoryChangeMobile()"
                            hide-details
                            density="compact"
                            item-title="text"
                        />
                    </v-col>
                    <v-col cols="12" style="max-height: 85vh; overflow-y: auto" class="py-2">
                        <DocumentRouterInExpenseReport
                            :mode="'GeneralLedger'"
                            :companyId="companyId"
                            :id="selectedDocument.id"
                            :dark-mode="true"
                        />
                    </v-col>
                </v-row>
            </oss-dialog>
        </div>
        <oss-dialog
            v-model="activeTravelExpense"
            title="Frais kilométriques"
            max-width="60vw"
            min-width="50vw"
        >
            <ExpenseReportAddress
                :travelExpense="currentTravelExpense"
                :isOwner="currentUser.id === creator.id"
                :expenseStatus="expenseReport.status"
                :year="year"
                @origin="setOrigin($event)"
                @destination="setDestination($event)"
            />

            <template v-slot:actions>
                <v-btn-primary
                    block
                    :disabled="
                        !expenseReport.name ||
                        !commonEnableModification ||
                        !currentTravelExpenseAmount
                    "
                    v-if="!currentTravelExpenseDocument"
                    @click="newTravelExpense()"
                    size="large"
                    >Ajouter</v-btn-primary
                >
                <v-btn-primary
                    block
                    v-if="currentTravelExpenseDocument"
                    @click="(modifyTravelExpense(), valideDestination())"
                    size="large"
                    >Modifier</v-btn-primary
                >
            </template>
            <!-- </v-row> -->
        </oss-dialog>
        <oss-dialog v-model="userDialog" :title="'Collaborateur'" max-width="800px">
            <select-user
                class="px-1"
                v-model="expenseReport.user"
                :companyId="companyId"
                :type="'NATURAL_PERSON'"
                @user-selected="userDialog = false"
            />
        </oss-dialog>
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer cette note de frais ?"
            validTitle="Supprimer"
            :error="true"
            @valid="deleteExpenseReport"
            prefixDataCy="ExpenseReport2-deleteValid"
            width="60vw"
        >
            Etes-vous sur de vouloir supprimer cette note de frais ?
        </oss-dialog>
        <DocumentWizardDialog
            v-model="activeUploadDocuments"
            :showFirstPrevious="false"
            :companyId="companyId"
            :documentType="'EXPENSE_REPORT_DOCUMENT'"
            :ownerId="expenseReportUserId"
            @new-document="onNewDocument($event)"
            @files-uploaded="filesUploaded()"
        />
    </v-container>
</template>
<script lang="ts">
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import moment from "moment-timezone";
import { Apollo } from "@/decorators";

import DELETE_EXPENSE_REPORT from "../../graphql/DeleteExpenseReport.gql";
import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";

import { User } from "../../../../types";
import { getUserDisplayName } from "../../services/userServices";

import { ExpenseReportBase } from "./ExpenseReportBase";
import DocumentWizardDialog from "../document/DocumentWizardDialog.vue";
import Chat from "../chat/Chat.vue";
import SelectUser from "../user/SelectUser.vue";
import ossPdf from "../document/DocumentPDF.vue";
import AccountingItemStatic from "../AccountingItemStatic.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";

import BobbeeImg from "../../assets/img/bobbee3d/bobbee3dTuto.png";
import FreeTag from "../tag/FreeTag.vue";
import HereMap from "../HereMap.vue";
import HereAddress from "../HereAddress.vue";
import ExpenseReportAddress from "./ExpenseReportAddress.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import emitter from "@/services/emitter";
import DocumentRouterInExpenseReport from "../document/DocumentRouterInExpenseReport.vue";

import { MenuDisplayDotMenuOptions, MenuDisplayOptions } from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";
import { DocumentMenu } from "../document/DocumentMenu.vue";

@Component({
    components: {
        DocumentWizardDialog,
        Chat,
        SwipeList,
        SwipeOut,
        SelectUser,
        ossPdf,
        AccountingItemStatic,
        HereMap,
        HereAddress,
        ExpenseReportAddress,
        DocumentRouterInExpenseReport,
        FreeTag,
        UsersActivitiesHistory,
        DocumentMenu
    },
})
export class ExpenseReport extends ExpenseReportBase {
    leftPart = "document";

    refreshKey = 0;
    switch1 = false;
    switch2 = false;

    hereAddressData = {
        latitude: 0,
        longitude: 0,
        hereAddressDialog: false,
    };

    step = 0;
    selectedDocumentId = "";

    userDialog = false;
    deleteDialog = false;

    selectedExpenseReport = null;

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenu: MenuDisplayDotMenuOptions = { ...documentMenuDisplayOptionsDefaultScheme.dotMenu };

        dotMenu.isDisplay = true;

        dotMenu.document.isDisplay = this.expenseReport.status === 'VALIDATED' && this.isAccountingUser;
        dotMenu.document.title = "Document";

        dotMenu.accountingLine.isDisplay = this.expenseReport.status === 'VALIDATED' && this.isAccountingUser;
        dotMenu.accountingLine.title = "Écritures comptables";

        dotMenu.activity.isDisplay = this.isAccountingUser;
        dotMenu.activity.title = "Afficher l'activité";

        dotMenu.delete.isDisplay = true;
        dotMenu.delete.title = "Supprimer";

        return dotMenu
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = { ...documentMenuDisplayOptionsDefaultScheme };

        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    get activateTagguing() {
        return true;
    }

    get displayHereMap() {
        return !!(
            (this.currentTravelExpense?.origin?.wordingAddress &&
                this.currentTravelExpense?.destination?.wordingAddress) ||
            (this.selectedDocument?.travelExpense?.origin?.wordingAddress &&
                this.selectedDocument?.travelExpense?.destination?.wordingAddress)
        );
    }

    get hereMapData() {
        if (
            this.currentTravelExpense?.origin?.wordingAddress &&
            this.currentTravelExpense?.destination?.wordingAddress
        ) {
            return {
                origin: this.currentTravelExpense.origin,
                destination: this.currentTravelExpense.destination,
                vehiculeType: this.currentTravelExpense.vehiculeType,
            };
        }
        if (
            this.selectedDocument?.travelExpense?.origin?.wordingAddress &&
            this.selectedDocument?.travelExpense?.destination?.wordingAddress
        ) {
            return {
                origin: this.selectedDocument.travelExpense.origin,
                destination: this.selectedDocument.travelExpense.destination,
                vehiculeType: this.selectedDocument.travelExpense.vehiculeType,
            };
        }
        return null;
    }

    valideDestination() {
        this.refreshKey++;
    }

    // actions = {
    //     action: new DialogAction()
    // }

    beforeMount() {
        this._mounted();
        emitter.$on("launchTuto", this.startTuto);
    }

    formatDate(date): string {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    @Apollo(
        {
            query: COMPANY_USERS,
            variables() {
                return {
                    companyId: this.companyId,
                };
            },
        },
        (data) => (data && data.users ? data.users : []),
    )
    users: User[] = [];

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    async onNewDocument(document) {
        this.newDocument(document);
    }

    async filesUploaded() {
        this.onFilesUploaded();
        await this.save();
        this.activeUploadDocuments = false;
        // await this.save()
    }

    routeDocument(id) {
        debugger;
        this.selectedDocumentId = id;
        this.step = 1;
    }

    back() {
        this.$router.go(-1);
    }

    setSelectedDocument(document) {
        this.selectedDocument = document;
        if (document.travelExpense) {
            this.selectedExpenseReport = document.travelExpense;
        } else {
            this.selectedExpenseReport = null;
        }
    }

    async categoryChangeMobile() {
        await this.categoryChange(this.selectedDocument);
        const documents = this.expenseReport.documents;
        const currentIndex = documents.findIndex((x) => x.id === this.selectedDocument.id);
        for (let i = currentIndex; i < documents.length; i++) {
            if (!documents[i].travelExpense) {
                if (documents[i].accountableAccount.name.startsWith("600000")) {
                    this.selectedDocument = this.expenseReport.documents[i];
                    return;
                }
            }
        }
        this.accountableAccountDialog = false;
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: null,
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "La validation du relevé bancaire se fait en plusieurs étapes",
                        img: BobbeeImg,
                        outed: true,
                    },
                ],
            },
            {
                ref: document.getElementById("InvoiceDocumentValidationNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Dans un premier temps, bobbee a analysé votre relevé bancaire.",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("StatutNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous pouvez suivre le statut du traitement de votre note de frais",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("createByNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous avez la personne qui a créer la note de frais",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("NameNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous avez le nom de la note de frais",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("DateNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous avez La date de la note de frais",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("TagNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous avez l'étiquette de la note de frais",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("CollaborationNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous avez le collaborateur de la note de frais",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("SupportingDocumentsNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Voici les justificatifs de la note de frais",
                        position: "left",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("TravellingExpensesNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous avez les frais de déplacement",
                        position: "left",
                        align: "start",
                    },
                ],
            },
            {
                ref: document.getElementById("DiversNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous avez d'autres paramètres de la note de frais",
                        position: "left",
                        align: "start",
                    },
                ],
            },
            {
                ref: document.getElementById("RegisterNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous pouvez enregistrer la note de frais",
                        position: "left",
                        align: "start",
                    },
                ],
            },
            {
                ref: document.getElementById("ValidNoteDeFrais"),
                title: "Validation de la note de frais",
                pages: [
                    {
                        text: "Vous pouvez valider la note de frais",
                        position: "left",
                        align: "start",
                    },
                ],
            },
        ]);
    }

    async deleteExpenseReport() {
        await this.$apollo.mutate({
            mutation: DELETE_EXPENSE_REPORT,
            variables: {
                id: this.expenseReport.id,
            },
        });
        this.$router.go(-1);
    }

    getDocumentStatus(doc) {
        const status = doc.status;
        if (status === "VALIDATED") {
            if (doc.accountableAccount.name && doc.accountableAccount.name !== "600000") {
                return "VALIDATED";
            }
            return "CATEGORY_NEEDED";
        }
        return status;
    }

    /*get expenseReportId() {
        return this.expenseReport.documents.id
    }*/

    prevNext = {
        prev: "",
        next: "",
    };
    /*console.log("ExpenseReport id is :");
    console.log(expenseReportId);*/

    // @Watch('expenseReportId', { immediate : true })
    // async getPrevNext() {
    //     const companyId = this.companyId;

    //     const preFilter = {
    //         search: this.$store.state.expenseReportsFilter.search,
    //         amount: this.$store.state.expenseReportsFilter.amount,
    //         date: this.$store.state.expenseReportsFilter.date,
    //         status: this.$store.state.expenseReportsFilter.status
    //     }

    //     const filter = getCommonExpenseReportWhere(preFilter);

    //     let result = await this.$apollo.query({
    //         query: GET_PREV_NEXT_EXPENSE_REPORT,
    //         variables: {
    //             companyId: companyId,
    //             id: this.expenseReportId,
    //             filter: filter
    //         }
    //     });
    //     console.log(result.data.getPrevNextExpenseReport);
    //     this.prevNext = { ...result.data.getPrevNextExpenseReport};
    // }

    get nextDisabled() {
        if (this.prevNext.next) {
            return false;
        }
        return true;
    }

    next() {
        const nextId = this.prevNext.next;
        if (!nextId) {
            debugger;
            return;
        }
        this.$router.replace({
            name: "expenseReport",
            params: {
                companyId: this.companyId,
                id: nextId,
            },
        });
    }

    get prevDisabled() {
        if (this.prevNext.prev) {
            return false;
        }
        return true;
    }

    prev() {
        const prevId = this.prevNext.prev;
        if (!prevId) {
            debugger;
            return;
        }
        this.$router.replace({
            name: "expenseReport",
            params: {
                companyId: this.companyId,
                id: prevId,
            },
        });
    }
}

export default toNative(ExpenseReport);
</script>

<style scoped>
.element-diplayed {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}
.oss-list-item {
    width: 100%;
}
</style>
